<script>
export default {
    
}
</script>

<template>
    <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSePeji97-7kE7nbxLaJh2g7d4Km9LqW6x_pW40IB9mqbD2a-g/viewform?embedded=true" width="700" height="2815" frameborder="0" marginheight="0" marginwidth="0">Loading...</iframe>
</template>

<style lang="scss" scoped>

iframe {
    padding-top: 2%;
    width: 100%;
}

</style>